import type { RuntimeConfig } from "nuxt/schema";
import type { PROVIDER_NAMES, AuthModuleOptions } from "../types";

export function queryParamToProviderName(value: string): PROVIDER_NAMES | undefined {
  switch (value.toLowerCase()) {
    case "hygiena":
      return "hygiena";
    case "msal":
    case "azure":
      return "msal-browser";
    case "test":
      return "test";
  }
}

export function providerNameToQueryParam(provider?: PROVIDER_NAMES): string | undefined {
  switch (provider) {
    case "hygiena":
      return "hygiena";
    case "msal-browser":
      return "msal";
    case "test":
      return "test";
  }
}

export function getAuthOptions(config: RuntimeConfig) {
  return config.public.AUTH_OPTIONS as AuthModuleOptions;
}

export function getHygienaOptions(config: RuntimeConfig) {
  const hygienaConfig = getAuthOptions(config).hygiena;
  if (!hygienaConfig) {
    throw new Error("Missing required Hygiena configuration");
  }
  if (!hygienaConfig.appName) {
    throw new Error("Missing required Hygiena appName configuration");
  }
  if (!hygienaConfig.baseUrl) {
    throw new Error("Missing required Hygiena baseUrl configuration");
  }

  return hygienaConfig;
}
